import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PagedApiRequest, PagedApiResponse } from '@fmnts/api/shared';
import { ApiConfigService, ApiRequestHelper } from '@fmnts/api/util';
import { hasProperty, isString } from '@fmnts/core';
import { EMPTY, expand, map, Observable, reduce } from 'rxjs';
import { IApiAchievement } from '../api-model';

export declare type GetNextAchievementListQuery = PagedApiRequest;
const hasNextPage = hasProperty('next', isString);

@Injectable({ providedIn: 'root' })
export class AchievementNextApi {
  private static readonly rootUrl = '/api/next/achievements';
  private readonly http = inject(HttpClient);
  private readonly apiHelper = inject(ApiRequestHelper);
  private readonly configService = inject(ApiConfigService);
  constructor() {}

  checkNewAchievements(): Observable<IApiAchievement[]> {
    const url = this.configService.buildApiUrl([
      AchievementNextApi.rootUrl,
      'check',
    ]);
    const headers = this.apiHelper.makeDefaultHeaders({});
    const params = this.apiHelper.makeParams({});
    return this.http.get<IApiAchievement[]>(url, { headers, params });
  }
  /**
   * List of achievements of a fundraiser.
   *
   * @returns
   * An 'Observable' that emits a paginated list of achievements.
   */

  list(
    query: GetNextAchievementListQuery = {},
  ): Observable<PagedApiResponse<IApiAchievement>> {
    const url = this.configService.buildApiUrl([AchievementNextApi.rootUrl]);
    const headers = this.apiHelper.makeDefaultHeaders({});
    const params = this.apiHelper.makeParams(query);
    return this.http
      .get<PagedApiResponse<IApiAchievement>>(url, { headers, params })
      .pipe(map((response) => response));
  }
  /**
   * List of all achievements of a fundraiser.
   * Call 'list' edpoint until all pages are feched
   *
   * @param query
   * @returns
   * An Observable containing an array of all Achievements
   */
  listAll(): Observable<IApiAchievement[]> {
    const query = { page_size: 20 };
    return this.list(query).pipe(
      expand((response) =>
        hasNextPage(response)
          ? this.list({ ...query, page: response.current_page + 1 })
          : EMPTY,
      ),
      reduce(
        (acc, current) => acc.concat(current.results),
        [] as IApiAchievement[],
      ),
    );
  }
}
